import { deserialize, Expose, Serializable, Type } from '@tokeet/tv3-platform'

export const CalendarEventTypeOther = { id: 0, name: 'Other' }
export const CalendarEventTypePersonal = { id: 1, name: 'Personal' }
export const CalendarEventTypeMaintenance = { id: 2, name: 'Maintenance' }
export const CalendarEventTypePending = { id: 3, name: 'Pending' }
export const CalendarEventTypeConfirmed = { id: 4, name: 'Confirmed' }

export const CalendarEventTypesMapping = {
  [CalendarEventTypeOther.id]: CalendarEventTypeOther,
  [CalendarEventTypePersonal.id]: CalendarEventTypePersonal,
  [CalendarEventTypeMaintenance.id]: CalendarEventTypeMaintenance,
  [CalendarEventTypePending.id]: CalendarEventTypePending,
  [CalendarEventTypeConfirmed.id]: CalendarEventTypeConfirmed,
}

export class CalendarEvent extends Serializable<CalendarEvent> {
  @Expose({ name: 'pkey' })
  id: string

  @Expose({ name: 'guest_id' })
  guestId: string

  @Expose({ name: 'booking_id' })
  bookingId: string

  @Expose({ name: 'rental_id' })
  rentalId: string

  @Expose({ name: 'ref_id' })
  refId: string

  @Expose({ name: 'created_by' })
  createdBy: string

  @Expose({ name: 'notes_updated' })
  notesUpdated: 0 | 1

  cost: string
  @Expose()
  @Type(() => Number)
  start: number
  @Expose()
  adults: number
  @Expose()
  source: string
  @Expose()
  checkout: number
  @Expose()
  children: number
  @Expose()
  @Type(() => Number)
  end: number
  email: string
  @Expose()
  title: string
  @Expose()
  checkin: number
  @Expose()
  type: number
  account: number
  expires: number
  rolling: number
  @Type(() => Number)
  created: number

  color: string

  static deserialize(data: any): CalendarEvent {
    data.pkey = data.pkey || data.booking_id
    return deserialize(CalendarEvent, data)
  }
}
